"use client";

import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Autoplay,
  EffectCoverflow,
  Pagination,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination'; 
import 'swiper/css/autoplay';
import "swiper/css/effect-coverflow";

import "@/styles/services/customCardCarousel.css";

const AnimatedCarousel = ({
  children,
  className = "",
  showControls = true,
  ...swiperProps
}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperReady, setSwiperReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (prevRef.current && nextRef.current) {
        setSwiperReady(true);
      }
    }, 50);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="relative w-full group">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation={
          swiperReady
            ? {
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }
            : false
        }
        loop={true}
        speed={1600}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: false,
        }}
        slidesPerView={2}
        freeMode={{ enabled: true, momentum: false, sticky: false }}
        spaceBetween={16}
        className={`w-full h-fit ${className} swiper-transition`}
        lazyPreloadPrevNext={true}
        {...swiperProps}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>

      {showControls && (
        <>
          <div className="absolute top-0 left-0 h-full w-36 sm:w-44 mobile:w-52 md:w-60 lg:w-72 xl:w-96 3xl:w-[420px] 4xl:w-[480px] bg-gradient-to-r from-background/90 to-transparent pointer-events-none z-10" />
          <div className="absolute top-0 right-0 h-full w-36 sm:w-44 mobile:w-52 md:w-60 lg:w-72 xl:w-96 3xl:w-[420px] 4xl:w-[480px] bg-gradient-to-l from-background/90 to-transparent pointer-events-none z-10" />
        </>
      )}
    </div>
  );
};

export default AnimatedCarousel;

export const CustomCardCarousel = ({ items }) => {
  return (
    <div className="servicepage-carousel">
      <div className="carousel-container">
        <Swiper
          modules={[Autoplay, EffectCoverflow, Pagination]}
          effect="coverflow"
          grabCursor={false}
          slidesPerView={3}
          loop={true}
          speed={1000}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false, // keeps autoplay after hover
            reverseDirection: true, // autoplay direction to right
          }}
          allowTouchMove={false} // no manual swiping
          centeredSlides={true}
          className="w-full"
          coverflowEffect={{
            rotate: 0, // no rotation
            stretch: 0,
            depth: 200, // depth effect for z-axis (card appears closer/farther)
            modifier: 2, // how strong the effect is
            slideShadows: false,
          }}
          pagination={{
            clickable: false,
            renderBullet: (index, className) =>
              `<span class="${className} custom-dot"></span>`,
          }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>{item}</SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
